import React, {Component} from 'react';
import Loader from "../../components/Loader";
class Uploading extends Component {
    render() {
        return (<Loader />);
    }
}
export default Uploading;